import { Building2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function SelectOrgPrompt() {
  const { user } = useAuth();
  if (!user || user.role !== 'super_admin') return null;

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="select-org-prompt">
      <div className="text-center max-w-sm">
        <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
          <Building2 className="w-7 h-7 text-gray-400" />
        </div>
        <h2 className="text-lg font-semibold text-gray-800 mb-1">No Organization Selected</h2>
        <p className="text-sm text-gray-500">
          Select an organization from the menu to view its data.
        </p>
      </div>
    </div>
  );
}

export function useNeedsOrg() {
  const { user, selectedTenants } = useAuth();
  // Provider accounts use the org switcher, not tenant selection
  if (user?.account_type === 'provider') return false;
  return user?.role === 'super_admin' && selectedTenants.length === 0;
}
